<script lang="ts">
  import Arrow from "$components/arrow/index.svelte";
  import LinkComp from "$components/link.svelte";
  import { utils } from "$lib/utils";
  import ImageComp from "$components/image.svelte";

  interface ITopTournaments {
    title: string;
    slug: string;
    logo: { path: string };
    colour: string;
    listed: number;
    nextGame: string;
    product: { proceedPrice: number; currency: string };
    datetime: string;
    performerCount: number;
  }

  export let topTournaments: ITopTournaments[] = [];
  export let locale: string = "";

  function getTournamentColour(colour: string) {
    return `background:linear-gradient( ${colour || "#d2d2d2"},#d2d2d2);`;
  }

  let mobileVisible = 4;
</script>

<div class="top-tournament-container">
  <div class="tournament-container">
    {#each topTournaments.slice(0, 8) as tournament, i}
      {@const { title, slug, logo, colour, listed, nextGame, product, performerCount } = tournament}
      {@const background = getTournamentColour(colour)}
      <LinkComp href={slug} className={i > mobileVisible ? "desk-only" : ""}>
        <section class="single-tickets grid" style={background}>
          <div class="inner grid">
            <div class="single-logo">
              <ImageComp image={logo} />
            </div>
            <div class="content grid">
              <h3 class="pf-500">{title}</h3>
              <hr class="desk-only" />
              <p class="pf-300">{listed} games listed</p>
              <!-- <p class="pf-500">Next game: {nextGame}</p> -->
              <p class="pf-500">{performerCount || 0} Teams</p>
              <hr class="desk-only" />
              <p class="pf-500 desk-only">
                {#if product}
                  Tickets From: {utils.nt(product?.proceedPrice || 0, locale, product?.currency || "")}
                {:else}
                  No ticket listed{/if}
              </p>
            </div>
            <div class="arrow-wrapper grid mob-only">
              <div>
                <Arrow />
              </div>
            </div>
            <button class="desk-only">View Fixtures</button>
          </div>
        </section>
      </LinkComp>
    {/each}
  </div>
</div>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;

  .top-tournament-container {
    background: var(--background-color);
    border-radius: 0.3125em;
    padding: 1.06em 1em;
    @include desktop {
      padding: 0;
    }
  }

  .tournament-container {
    display: grid;
    @include desktop {
      background: #fff;
      grid-template-columns: repeat(4, 23.85%);
      gap: 1.25em;
    }
  }

  .single-tickets {
    @include desktop {
      padding: 1px;
      border-radius: 6px;
    }
  }

  .inner {
    background: #fbfbfb;
    padding: 1.1em 0;
    grid-template-columns: 4.125em auto 3.125em;
    gap: 0;
    border-bottom: 1px solid #d8d8d8;

    @include desktop {
      padding: 1.62em 1.12em;
      grid-template-columns: 1fr;
      grid-template-rows: 20% 65% 15%;
      height: 22em;
      border-radius: 5px;
      border-bottom: none;
    }
  }

  .single-logo {
    width: 2.8125em;
    height: 2.8125em;
    align-self: center;
    @include desktop {
      justify-self: center;
    }
  }

  .content {
    grid-template-columns: 1fr;
    color: #000;
    border-left: 1px solid var(--hr-color);
    padding: 0 0.88em;
    gap: 0.5em 0;
    @include desktop {
      padding: 1em 0;
      border-left: unset;
      margin-bottom: 1.75em;
      text-align: center;
    }
    h3,
    p {
      margin: 0;
      color: #000;
      line-height: 1.1875em;
    }
    h3 {
      font-size: 1em;
      @include desktop {
        font-size: 1.25em;
      }
    }
    p {
      font-size: 0.8125em;
      @include desktop {
        font-size: 1em;
      }
    }

    hr {
      margin: auto;
      width: 2.1875em;
      height: 0.0625em;
    }
  }

  .arrow-wrapper {
    div {
      align-self: center;
      justify-self: end;
    }
  }

  button {
    max-height: 2.75em;
    line-height: 0.75em;
    font-weight: 500;
    font-family: Nunito;
  }
</style>
